import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.axios.defaults.timeout = 60 * 1000
Vue.axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.axios.defaults.baseURL = document.getElementById('app').getAttribute('base-uri') || process.env.baseURL || process.env.VUE_APP_API_URL || ''
